import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { iconMap, type ServiceMeta } from "@/lib/serviceMeta";

const ServicesSection = () => {
  const { data: services = [] } = useQuery({
    queryKey: ["posts", "services-home"],
    queryFn: async () => {
      const { data } = await supabase
        .from("posts")
        .select("*")
        .eq("section", "services")
        .order("sort_order");
      return data || [];
    },
  });

  const ref = useScrollReveal([services]);

  return (
    <section id="services" className="py-20 bg-secondary/50" ref={ref}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 animate-on-scroll">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            השירותים <span className="text-primary">שלנו</span>
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            מגוון שירותי גגות ופחחות מקצועיים – הכל תחת קורת גג אחת
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {services.map((service, i) => {
            const meta = service.metadata as ServiceMeta;
            const IconComp = meta?.icon ? iconMap[meta.icon] : undefined;
            return (
              <Card
                key={service.id}
                className="animate-on-scroll card-shine hover-lift group border-border bg-card relative"
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <CardHeader className="pb-3 relative z-10">
                  {IconComp && (
                    <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-3 transition-all duration-300 group-hover:bg-primary group-hover:scale-110 group-hover:rotate-6">
                      <IconComp className="text-primary transition-colors duration-300 group-hover:text-primary-foreground" size={24} />
                    </div>
                  )}
                  <CardTitle className="text-xl text-foreground transition-colors group-hover:text-primary">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {service.subtitle && (
                    <p className="text-muted-foreground leading-relaxed">{service.subtitle}</p>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
